(() => {
  "use strict";
  if (location.protocol !== "https:" || !["greyimportspares.com", "www.greyimportspares.com"].includes(location.hostname)) return;
  const nativeFetch = window.fetch.bind(window);
  const cookie = "; Domain=greyimportspares.com; Path=/; Secure; SameSite=Lax";
  const helper = /\/pages\/catalogue-cart\/?$/.test(location.pathname);
  let pending, again = false;
  function unusable(message) {
    document.cookie = `__Secure-partseeker_cart_id=${cookie}; Max-Age=0`;
    throw new Error(message);
  }
  function refresh() {
    if (pending) { again = true; return pending; }
    pending = (async () => {
      const response = await nativeFetch(`${window.Shopify.routes.root}cart.js`, { credentials: "same-origin", cache: "no-store" });
      if (!response.ok) throw new Error("Cart lookup failed.");
      const cart = await response.json();
      const token = cart.token;
      if (typeof token !== "string" || !token.includes("?key=") || !token.split("?key=")[1] || /[\x00-\x20\x7f]/.test(token)) unusable("Cart identifier unavailable.");
      const value = encodeURIComponent(token);
      // shortcut: oversized cart credentials cannot fit a cookie; use server storage if Shopify increases their size.
      if (value.length > 3500) unusable("Cart identifier is too large.");
      document.cookie = `__Secure-partseeker_cart_id=${value}${cookie}; Max-Age=1209600`;
      if (!document.cookie.split("; ").includes(`__Secure-partseeker_cart_id=${value}`)) throw new Error("Cart cookie could not be saved.");
    })().finally(() => {
      pending = null;
      if (again) { again = false; refresh().catch(() => {}); }
    });
    return pending;
  }
  function schedule() { refresh().catch(() => {}); }
  function mutation(url, method) {
    try {
      const parsed = new URL(url, location.href);
      return parsed.origin === location.origin && method.toUpperCase() === "POST" && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(parsed.pathname);
    } catch { return false; }
  }
  window.fetch = function(input, options) {
    const result = nativeFetch(input, options);
    if (mutation(typeof input === "string" || input instanceof URL ? String(input) : input.url, options?.method || input?.method || "GET")) {
      result.then(response => { if (response.ok) schedule(); }, () => {});
    }
    return result;
  };
  if (window.XMLHttpRequest) {
    const original = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      const changed = mutation(url, method);
      this.addEventListener("load", () => { if (changed && this.status >= 200 && this.status < 300) schedule(); }, { once: true });
      return original.call(this, method, url, ...rest);
    };
  }
  window.addEventListener("pageshow", schedule);
  window.addEventListener("partseeker:cart-changed", schedule);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") schedule(); });
  if (!helper) { schedule(); return; }
  let destination;
  try {
    destination = new URL(new URL(location.href).searchParams.get("return_to"));
    if (!["https://yamaha.greyimportspares.com", "https://kawasaki.greyimportspares.com"].includes(destination.origin) || destination.username || destination.password) throw new Error();
  } catch {
    const message = document.createElement("p");
    message.textContent = "The catalogue return address is invalid. Please use the shop cart to continue.";
    document.body.append(message);
    return;
  }
  const status = document.createElement("p");
  status.setAttribute("role", "status");
  const retry = document.createElement("button");
  retry.type = "button"; retry.textContent = "Retry returning to catalogue";
  document.body.append(status, retry);
  async function returnToCatalogue() {
    retry.hidden = true; status.textContent = "Returning to the catalogue…";
    try {
      await refresh();
      destination.searchParams.set("cart_added", "1");
      location.replace(destination.href);
    } catch {
      status.textContent = "Your cart could not be shared. Retry to return to the catalogue, or open the shop cart. Your item will not be added again.";
      retry.hidden = false;
    }
  }
  retry.addEventListener("click", returnToCatalogue);
  returnToCatalogue();
})();
